import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  UserConnectedLeadersListLoadAction,
  UserConnectedLeadersListLoadMoreAction,
} from '../../domains/leadersManagement/actions.types';

import { UserConnectedLeaders } from './types';

export type UserConnectedLeadersAction = UserConnectedLeadersListLoadAction | UserConnectedLeadersListLoadMoreAction;

const initialState: UserConnectedLeaders = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<UserConnectedLeaders, UserConnectedLeadersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CONNECTED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userConnectedLeaders);
    case 'CONNECTED_LEADERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userConnectedLeaders);
    default:
      return state;
  }
};

export default reducer;
